import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedToppagespress,
  addingToppagespress,
  addingToppagespressFailed,
  editedToppagespress,
  editingToppagespress,
  editingToppagespressFailed,
  foundToppagespress,
  loadedToppagespress,
  loadingToppagespress,
  loadingToppagespressFailed,
  removedToppagepress,
  removingToppagepress,
  removingToppagepressFailed,
  searchingToppagespress,
  searchingToppagespressFailed,
  softRemovedToppagespress,
  softRemovingToppagespress,
  softRemovingToppagespressFailed,
  ToppagespressAction,
  ToppagespressActionTypes,
} from '../actions/toppagespressActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchToppagespressEpic: Epic<ToppagespressAction, ToppagespressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagespressActionTypes.SEARCH_TOPPAGESPRESS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/toppagespress/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundToppagespress(response.data, action.keep)),
        startWith(searchingToppagespress()),
        catchError(() => of(searchingToppagespressFailed()))
      )
    })
  )

const loadToppagespressEpic: Epic<ToppagespressAction, ToppagespressAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(ToppagespressActionTypes.LOAD_TOPPAGESPRESS)),
    switchMap((action) => {
      let url = `${API_URL}/api/toppagespress/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedToppagespress(response.data)),
        startWith(loadingToppagespress()),
        catchError(() => of(loadingToppagespressFailed()))
      )
    })
  )
}

const addToppagespressEpic: Epic<ToppagespressAction, ToppagespressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagespressActionTypes.ADD_TOPPAGESPRESS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/toppagespress/`, data, config)).pipe(
        map((response) => addedToppagespress(response.data)),
        startWith(addingToppagespress()),
        catchError((err) => of(addingToppagespressFailed(err.response)))
      )
    })
  )

const removeToppagespressEpic: Epic<ToppagespressAction, ToppagespressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagespressActionTypes.REMOVE_TOPPAGEPRESS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/toppagespress/${action.payload._id}`)).pipe(
        map((response) => removedToppagepress()),
        startWith(removingToppagepress()),
        catchError(() => of(removingToppagepressFailed()))
      )
    )
  )

const softRemoveToppagespressEpic: Epic<ToppagespressAction, ToppagespressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagespressActionTypes.SOFT_REMOVE_TOPPAGESPRESS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/toppagespress/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedToppagespress(response.data.record)),
        startWith(softRemovingToppagespress()),
        catchError((err) => of(softRemovingToppagespressFailed(err.response)))
      )
    )
  )

const editToppagespressEpic: Epic<ToppagespressAction, ToppagespressAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ToppagespressActionTypes.EDIT_TOPPAGESPRESS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/toppagespress/${action.payload._id}`, data, config)).pipe(
        map((response) => editedToppagespress(response.data)),
        startWith(editingToppagespress()),
        catchError((err) => of(editingToppagespressFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchToppagespressEpic,
  loadToppagespressEpic,
  addToppagespressEpic,
  removeToppagespressEpic,
  softRemoveToppagespressEpic,
  editToppagespressEpic
)
